import { makeStyles } from "@mui/styles";

export const useSimpleTopBarStyles = makeStyles({
    root: {
        backgroundColor: "white",
    },
});
